var map = {
	"./access-credentials.svg": "7381",
	"./alipay.svg": "ef57",
	"./aliyun.svg": "f384",
	"./amd.svg": "cb33",
	"./apsara.svg": "3678",
	"./arrow-right.svg": "c061",
	"./aws.svg": "007c",
	"./azure.svg": "ccf18",
	"./bank-card.svg": "4c7c",
	"./bingocloud.svg": "c91f",
	"./blank.svg": "97bf",
	"./caret-down.svg": "9ff3",
	"./ceph.svg": "65ae",
	"./cloudpods.svg": "b3bdb",
	"./cloudshell.svg": "0f88",
	"./code.svg": "8e62",
	"./copy.svg": "2af7",
	"./coupon.svg": "3639",
	"./cpu.svg": "7ccc",
	"./ctyun.svg": "0367",
	"./daping.svg": "c2ab",
	"./dashboard-fee.svg": "39dd",
	"./dashboard-log.svg": "43c7",
	"./dashboard-notice.svg": "627b",
	"./dashboard-number.svg": "c6a7",
	"./dashboard-quota.svg": "c479",
	"./dashboard-resource.svg": "6146",
	"./dashboard-suggest-detail.svg": "9f0c",
	"./dashboard-suggest-overview.svg": "f626",
	"./dashboard-top5.svg": "3807",
	"./dashboard-trend.svg": "ebe9e",
	"./dashboard-usage.svg": "4247",
	"./data-empty.svg": "5213",
	"./delete.svg": "83f3",
	"./dingtalk.svg": "c060",
	"./download.svg": "ae84",
	"./dstack.svg": "25ae",
	"./email.svg": "88d6",
	"./excel.svg": "a3ff",
	"./feishu.svg": "ae63",
	"./gaokeyong.svg": "d05a",
	"./gold.svg": "e02e",
	"./google.svg": "16e6c",
	"./gpu.svg": "b393",
	"./h3c.svg": "7a85",
	"./hcs.svg": "5cab",
	"./hcso.svg": "6b31",
	"./hcsop.svg": "7376",
	"./help.svg": "4861",
	"./hp.svg": "e5b1",
	"./huawei.svg": "ea08",
	"./info.svg": "576a",
	"./info2.svg": "2bd1",
	"./integral.svg": "6bfc",
	"./jdcloud.svg": "ad2d",
	"./k8s.svg": "98a9",
	"./keypairs.svg": "b268",
	"./kongzhitai.svg": "21fd",
	"./logo.svg": "60e5",
	"./menu-compute.svg": "0933",
	"./menu-dashboard.svg": "d9aa",
	"./menu-db.svg": "51b1",
	"./menu-helm.svg": "6a6e",
	"./menu-iam.svg": "4eba",
	"./menu-k8s.svg": "f32f",
	"./menu-meter.svg": "37ba",
	"./menu-middleware.svg": "c22f",
	"./menu-monitor.svg": "ad70",
	"./menu-multicloud.svg": "b03c",
	"./menu-network.svg": "dfc3",
	"./menu-setting.svg": "7665",
	"./menu-storage.svg": "d96b",
	"./menu-tenant.svg": "bd46",
	"./menu.svg": "cea3",
	"./mobile.svg": "54a3",
	"./mongodb.svg": "ec40",
	"./more.svg": "60c7",
	"./move.svg": "9960",
	"./navbar-more.svg": "196b",
	"./navbar-notify.svg": "92db",
	"./navbar-process.svg": "e1c5",
	"./navbar-project.svg": "96bf",
	"./navbar-setting.svg": "433e",
	"./navbar-user.svg": "4e90",
	"./navbar-view-switch.svg": "3335",
	"./nutanix.svg": "e8a89",
	"./nvidia.svg": "3e78",
	"./onecloud-map.svg": "2405",
	"./onecloud.svg": "bfd5",
	"./openshift.svg": "5991",
	"./openstack.svg": "70a4",
	"./passthrough.svg": "d78b",
	"./password.svg": "327d",
	"./pdf.svg": "f2e9",
	"./projectmapping.svg": "3bcf",
	"./pull-down.svg": "1316",
	"./qcloud.svg": "26d5",
	"./question.svg": "2a5c",
	"./refresh.svg": "4a0f",
	"./res-access-group.svg": "24cc",
	"./res-baremetal.svg": "454d",
	"./res-blockstorage.svg": "0d53",
	"./res-bucket.svg": "1745",
	"./res-cdn-domain.svg": "9d98",
	"./res-cloudaccount.svg": "e7d8",
	"./res-cluster.svg": "eb1b",
	"./res-commonalert.svg": "b31e",
	"./res-contact.svg": "16da",
	"./res-disk-snapshot.svg": "a7a5",
	"./res-disk.svg": "44cc",
	"./res-dns.svg": "7e7e",
	"./res-domain.svg": "a07b",
	"./res-dynamicschedtag.svg": "42d2",
	"./res-eip.svg": "80df",
	"./res-elasticsearch.svg": "5b36",
	"./res-file-system.svg": "9890",
	"./res-flexnetwork.svg": "aca6",
	"./res-gpu.svg": "6629",
	"./res-group.svg": "7b64",
	"./res-host.svg": "450f",
	"./res-identity-provider.svg": "3bea",
	"./res-image.svg": "be77",
	"./res-instance-snapshot.svg": "4a37",
	"./res-instancegroup.svg": "e52e",
	"./res-ipv6-gateway.svg": "f7a8",
	"./res-k8s-chart.svg": "c02c",
	"./res-k8s-configmap.svg": "d502",
	"./res-k8s-cronjob.svg": "daaf",
	"./res-k8s-daemonset.svg": "4c97",
	"./res-k8s-deployment.svg": "855a",
	"./res-k8s-ingress.svg": "9d21",
	"./res-k8s-job.svg": "73c3",
	"./res-k8s-kubecluster.svg": "3575",
	"./res-k8s-kubecomponent.svg": "d415",
	"./res-k8s-namespace.svg": "697d",
	"./res-k8s-node.svg": "1d94",
	"./res-k8s-persistentvolumeclaim.svg": "aec9",
	"./res-k8s-pod.svg": "8de5e",
	"./res-k8s-rbacclusterrole.svg": "21c8",
	"./res-k8s-rbacclusterrolebinding.svg": "ba53",
	"./res-k8s-rbacrole.svg": "c705",
	"./res-k8s-rbacrolebinding.svg": "807f",
	"./res-k8s-release.svg": "07532",
	"./res-k8s-repo.svg": "0b09",
	"./res-k8s-secret.svg": "022f",
	"./res-k8s-service.svg": "3587",
	"./res-k8s-serviceaccount.svg": "0730",
	"./res-k8s-statefulset.svg": "5b85",
	"./res-k8s-storageclass.svg": "4316",
	"./res-kafka.svg": "6b82",
	"./res-keypair.svg": "28d9",
	"./res-kuaizhao.svg": "c3e8",
	"./res-kuaizhaocelue.svg": "b475",
	"./res-lb.svg": "ec3c",
	"./res-lbacl.svg": "9d25",
	"./res-lbbackendgroup.svg": "7f45",
	"./res-lbcert.svg": "70e6",
	"./res-lblistener.svg": "79af",
	"./res-lblistenerrule.svg": "2c339",
	"./res-month.svg": "f060",
	"./res-mount-target.svg": "39c1",
	"./res-nat.svg": "b79e",
	"./res-network.svg": "43aa",
	"./res-physicalmachine.svg": "1cd4",
	"./res-policy.svg": "09bc",
	"./res-policydefinition.svg": "2377",
	"./res-project.svg": "89e2",
	"./res-proxysetting.svg": "edba",
	"./res-rate.svg": "9b29",
	"./res-rds-backup.svg": "ca79",
	"./res-rds.svg": "283c",
	"./res-recovery.svg": "6541",
	"./res-redis.svg": "4aae8",
	"./res-region.svg": "2f17",
	"./res-repair-order-configuration.svg": "d7e0",
	"./res-resourcetype.svg": "2e77",
	"./res-role.svg": "ae82",
	"./res-scalinggroup.svg": "1971",
	"./res-schedpolicy.svg": "3abe",
	"./res-schedtag.svg": "3a9c",
	"./res-secgroup.svg": "9b8c4",
	"./res-servertemplate.svg": "aa8e",
	"./res-servicecatalog.svg": "8729",
	"./res-sku.svg": "ac37",
	"./res-strategy.svg": "48bf",
	"./res-suggestsalert.svg": "83c8",
	"./res-suggestsrule.svg": "7a4d",
	"./res-tag.svg": "d076a",
	"./res-user.svg": "be43",
	"./res-user2.svg": "b784",
	"./res-vminstance.svg": "6d21",
	"./res-vpc.svg": "37f4",
	"./res-webapp.svg": "b3e2",
	"./res-wire.svg": "ad3c",
	"./res-zone.svg": "842f",
	"./s3.svg": "b882",
	"./search.svg": "cb98",
	"./setting.svg": "dd9a",
	"./ssh.svg": "5a90",
	"./stars.svg": "002f",
	"./theme-setting.svg": "f529",
	"./transfer.svg": "89bb",
	"./ucloud.svg": "acd7",
	"./user-del.svg": "26be",
	"./user.svg": "bbbf",
	"./vmware.svg": "32e3",
	"./waf.svg": "78a6",
	"./webconsole.svg": "eedd",
	"./workwx.svg": "8294",
	"./xsky.svg": "3092",
	"./zizhanghao.svg": "ab70",
	"./zstack.svg": "1086"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3541";